import axios from 'axios';
import { InitiateRequest } from '../../Models/Request';
import { getAccessToken, setAccounts, setData } from '../../Utils/storageUtils';
import pfmClientAxiosInstance from './interceptor';

export const getMainDashboardData = () => {};

export function initiateAuth(initiateRequest: InitiateRequest) {
  return axios.post('/initiate', initiateRequest);
}

export const checkStatusOfConsent = async (data: any) => {
  const response = await pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/consent/status`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );

  return response;
};

export const getAccounts = async (data: any) => {
  const response = await pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/fetch-accounts`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );

  setAccounts(response.data);
  return response;
};

export const getData = async (data: any) => {
  const response = await pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/data`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );

  setData(response.data);
  return response;
};
